// extracted by css-extract-rspack-plugin
export default {"arrangement":"arrangement-V24kod"};